import * as Yup from 'yup'

import {
  dv360ImageFileShape,
  dv360MediaItemsValidationSchema
} from '../../../AdDv360Create/AdDv360CreateForm/Routes/CreativeFileUploadRoute/validation'
import { MEDIA_WIDTH, MEDIA_HEIGHT } from '../../../../../ReusableFormFields/AdFileUpload/fields'
import {
  initialDv360Media,
  MEDIA_ITEMS
} from '../../../AdDv360Create/AdDv360CreateForm/Routes/CreativeFileUploadRoute/fields'

// Yup validation schema
export const editDv360ImageSizeValidation = originalDimensions =>
  Yup.object()
    .shape(dv360ImageFileShape)
    .test(
      'validSize',
      `Invalid image dimensions, max width is: ${originalDimensions.width}px, max height is: ${originalDimensions.height}px.`,
      ad => {
        return isValidSize(originalDimensions, { width: ad[MEDIA_WIDTH], height: ad[MEDIA_HEIGHT] })
      }
    )

export const initialValues = {
  [MEDIA_ITEMS]: [initialDv360Media]
}

const isValidSize = (originalDimensions, newFileDimensions) => {
  // DV360 allows to upload images with the same dimensions as already uploaded
  const isWidthValid = Number(originalDimensions.width) === Number(newFileDimensions.width)
  const isHeightValid = Number(originalDimensions.height) === Number(newFileDimensions.height)
  return isWidthValid && isHeightValid
}
export const validationSchema = Yup.object({
  [MEDIA_ITEMS]: dv360MediaItemsValidationSchema
})
